module.exports = __webpack_public_path__ + "img/icon_map_2_yj_c.ab923df3.png";